import { FC } from 'react'

import { Link } from '@tanstack/react-router'
import { IconName, IconSize } from 'ui/components'

import { BSABreadcrumbsProps } from './BSABreadcrumbs.types'

import { s } from './styles'

export const BSABreadcrumbs: FC<BSABreadcrumbsProps> = (props) => {
  const { parentUrl, parentTitle, title } = props

  return (
    <s.Title>
      <Link to={parentUrl}>{parentTitle}</Link>
      <s.Arrow name={IconName.ARROW_SMALL} size={IconSize.XS} />
      {title}
    </s.Title>
  )
}
